import script from "./KontrakPage.vue?vue&type=script&setup=true&lang=js"
export * from "./KontrakPage.vue?vue&type=script&setup=true&lang=js"

import "./KontrakPage.vue?vue&type=style&index=0&id=7fc1deb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fc1deb4"]])

export default __exports__